module.exports = __webpack_public_path__ + "static/media/appstoreQR.c168d3eb.png";